"use client";

import { StoryblokComponentList } from "@trydig/storyblok";
import { useAtom } from "jotai";
import type { BlokAccordionGroupItem } from "@/storyblok";
import { selectedGroupAtom } from "../../config";

export interface AccordionGroupsContentProps {
	items: BlokAccordionGroupItem[];
	preview: boolean;
}

export const AccordionGroupsContent = ({
	items,
	preview,
}: AccordionGroupsContentProps) => {
	const [selectedGroup] = useAtom(selectedGroupAtom);

	return (
		<StoryblokComponentList
			bloks={items.filter((blok) => blok.title === selectedGroup)}
			preview={preview}
		/>
	);
};
